/**
 * Configuração centralizada de menus do sistema
 *
 * Estrutura de cada item de menu:
 * - titulo: string - Texto exibido no menu
 * - to: string - Rota Vue Router (opcional)
 * - href: string - Link externo fixo, abre em nova aba (opcional, alternativa a "to")
 * - icon: string - Ícone MDI
 * - permissao: string - Chave de permissão necessária (opcional)
 * - subMenuStatus: boolean - Se possui submenu
 * - subMenu: array - Lista de submenus (opcional)
 * - dataCriacao: string - Data de criação do menu (formato: YYYY-MM-DD)
 */

export const menuConfig = [
    {
        titulo: 'Dashboards',
        to: '/',
        icon: 'mdi-bullseye-arrow',
        subMenuStatus: false,
        subMenu: [],
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Aluguel',
        to: '/aluguel-equipamento',
        icon: 'mdi-file-document',
        permissao: 'aluguel_equipamento_menu',
        subMenuStatus: false,
        subMenu: [],
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'CD',
        to: '/cd',
        icon: 'mdi-package',
        permissao: 'cd_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Acompanhamento Logístico',
                to: '/entrega-domicilio',
                icon: 'mdi-map-marker-path',
                permissao: 'cd_menu_entrega_domicilio',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Estoque e Reserva - CD',
                to: '/cd',
                icon: 'mdi-package-variant',
                permissao: 'cd_menu_estoque_reserva_wms',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Gestão de Pre-cargas',
                to: '/gestaoprecarga',
                icon: 'mdi-truck-delivery-outline',
                permissao: 'cd_painel_precargas',
                dataCriacao: '2000-01-01'
            }
        ]
    },
    {
        titulo: 'Central BI',
        to: '/central_bi',
        icon: 'mdi-chart-timeline-variant-shimmer',
        permissao: 'central_bi_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Apoio à decisão 2',
                href: 'http://172.31.11.15:5800',
                icon: 'mdi-open-in-new',
                permissao: 'apoio_decisao_bi',
                dataCriacao: '2026-09-14'
            },
            {
                titulo: 'Ajuste Estoque BI',
                to: '/central_bi/ajusteestoquebi',
                icon: 'mdi-archive-alert',
                permissao: 'ajusteestoque_bi',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Pedidos vs Abastecimento',
                to: '/central_bi/analisetvabastecimento',
                icon: 'mdi-warehouse',
                permissao: 'analise_x_abastecimento_bi',
                dataCriacao: '2026-03-01'
            },
            {
                titulo: 'Est. Virtual X Divergências BI',
                to: '/central_bi/divergenciasbi',
                icon: 'mdi-comment-alert',
                permissao: 'divergencias_bi',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Estoque BI',
                to: '/central_bi/estoquebi',
                icon: 'mdi-file-table-box-outline',
                permissao: 'estoque_bi',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Gestão de Perdas de Estoque',
                to: '/gestao-rotativos/dashboard',
                icon: 'mdi-package-down',
                permissao: 'central_bi_menu_gestao_rotativos',
                dataCriacao: '2025-10-15'
            },
            {
                titulo: 'Giro e Cobertura BI',
                to: '/central_bi/girobi',
                icon: 'mdi-cached',
                permissao: 'giro_bi',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Pricing BI',
                to: '/pricing',
                icon: 'mdi-currency-usd',
                permissao: 'price_bi',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Vendas BI',
                to: '/central_bi/vendasbi',
                icon: 'mdi-chart-line',
                permissao: 'vendas_bi',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Ranking Vendedores BI',
                to: '/central_bi/vendas_vendedor_bi',
                icon: 'mdi-chart-line',
                permissao: 'vendas_vendedor_bi',
                dataCriacao: '2025-12-01'
            }
        ]
    },
    {
        titulo: 'Clientes',
        icon: 'mdi-card-account-details',
        permissao: 'cliente_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Análise de Crédito',
                to: '/analise',
                icon: 'mdi-credit-card-check',
                permissao: 'analise_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Consulta de Limite',
                to: '/consulta-credito',
                icon: 'mdi-credit-card-search-outline',
                permissao: 'sortercurve_menu',
                dataCriacao: '2026-01-28'
            },
            {
                titulo: 'Contratos',
                to: '/contrato',
                icon: 'mdi-file-sign',
                permissao: 'contrato_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Credu',
                to: '/credu',
                icon: 'mdi-wallet',
                permissao: 'credu_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Entregas',
                to: '/entrega',
                icon: 'mdi-truck-outline',
                permissao: 'entrega_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Manutenção de Clientes',
                to: '/cliente',
                icon: 'mdi-account-edit',
                permissao: 'submenu_manutencao_cliente',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Parcelamentos e Crediário',
                to: '/parcelamento',
                icon: 'mdi-calendar-month',
                permissao: 'parcelamento_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Seguros',
                to: '/seguro',
                icon: 'mdi-shield-check',
                permissao: 'seguro_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Serviços de Crédito',
                to: '/servicocredito',
                icon: 'mdi-cash-multiple',
                permissao: 'servico_credito_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Sorteios e Cupons',
                to: '/sorteio',
                icon: 'mdi-ticket-percent',
                permissao: 'sorteio_menu',
                dataCriacao: '2000-01-01'
            }
        ]
    },
    {
        titulo: 'Compras',
        to: '/compras',
        icon: 'mdi-cart',
        permissao: 'compras_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Análise de Abastecimento',
                to: '/ruptura-abastecimento',
                icon: 'mdi-package-variant-closed-remove',
                permissao: 'rupturas_menu',
                dataCriacao: '2026-02-13'
            },
            {
                titulo: 'Cadastro de produtos',
                to: '/compras',
                icon: 'mdi-package-variant-closed',
                permissao: 'compras_cadastro_produtos',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Controle de Gaiolas',
                to: '/controle/gaiola',
                icon: 'mdi-grid',
                permissao: 'controle_gaiola',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Orçamento Compras',
                to: '/pedido_compra',
                icon: 'mdi-clipboard-text',
                permissao: 'menu_pedidos_compra',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Unificador de pedidos',
                to: '/unificador',
                icon: 'mdi-file-document-multiple',
                permissao: 'unificador_pedidos',
                dataCriacao: '2000-01-01'
            }
        ]
    },
    {
        titulo: 'DP & RH',
        icon: 'mdi-account-group',
        permissao: 'departamento_pessoal_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Departamento Pessoal',
                to: '/departamento-pessoal-antigo',
                icon: 'mdi-account-group-outline',
                permissao: 'departamento_pessoal_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Apuração da Folha',
                to: '/departamento-pessoal/exportador-senior',
                icon: 'mdi-clipboard-check-outline',
                permissao: 'dp_fechamento_folha_menu',
                dataCriacao: '2026-03-11'
            }
        ]
    },
    {
        titulo: 'Filiais',
        icon: 'mdi-store',
        permissao: 'filial_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Balanço',
                to: '/balanco',
                icon: 'mdi-counter',
                permissao: 'balanco_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Comissão',
                to: '/comissao',
                icon: 'mdi-cash',
                permissao: 'comissao_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Metas e Filiais',
                to: '/filial',
                icon: 'mdi-target',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Remissões',
                to: '/remissao',
                icon: 'mdi-file-send',
                permissao: 'remissao_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Usuários',
                to: '/usuario',
                icon: 'mdi-account-multiple',
                permissao: 'usuario_menu',
                dataCriacao: '2000-01-01'
            }
        ]
    },
    {
        titulo: 'GPP',
        to: '/gpp',
        icon: 'mdi-account-group-outline',
        permissao: 'gpp_menu',
        subMenuStatus: false,
        subMenu: [],
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Logística',
        to: '/logistica',
        icon: 'mdi-truck',
        permissao: 'logistica_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Acompanhamento de Lotes',
                to: '/logistica',
                icon: 'mdi-package-variant-closed-check',
                permissao: 'logistica_menu_dash_lotes',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Gestão de Frota',
                to: '/gestao-frota',
                icon: 'mdi-truck-fast',
                permissao: 'logistica_menu_gestao_frota',
                dataCriacao: '2000-01-01'
            },
            // {
            //     titulo: 'Transferência entre Filiais',
            //     to: '/transferencia',
            //     icon: 'mdi-swap-horizontal-bold',
            //     permissao: 'transferencia_menu',
            //     dataCriacao: '2026-02-10'
            // }
        ]
    },
    {
        titulo: 'Marketing',
        to: '/marketing',
        icon: 'mdi-image-multiple-outline',
        permissao: 'marketing_menu',
        subMenuStatus: false,
        subMenu: [],
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Ti',
        icon: 'mdi-laptop',
        permissao: 'ti_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: 'Tecnologia da Informação',
                to: '/ti',
                icon: 'mdi-laptop-account',
                permissao: 'ti_menu',
                dataCriacao: '2000-01-01'
            }
        ]
    },
    {
        titulo: 'Vendas',
        to: '/venda',
        icon: 'mdi-sale',
        permissao: 'venda_menu',
        subMenuStatus: true,
        dataCriacao: '2000-01-01',
        subMenu: [
            {
                titulo: '* Tele-vendas',
                to: '/venda',
                icon: 'mdi-phone-in-talk',
                permissao: 'televenda_submenu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: '* Venda de Concreto',
                to: '/concreto',
                icon: 'mdi-cement-bag',
                permissao: 'concreto_submenu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: '* Vendas e comissões',
                to: '/comissao/simulador',
                icon: 'mdi-calculator-variant',
                permissao: 'comissao_vendas',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Controle de Visitas',
                to: '/controle_visitas',
                icon: 'mdi-car-lifted-pickup',
                permissao: 'controle_visitas_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Energia Solar',
                to: '/calculadorasolar',
                icon: 'mdi-solar-power',
                permissao: 'calculadora_solar_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Etiquetas',
                to: '/etiqueta',
                icon: 'mdi-tag-multiple',
                permissao: 'etiquetas_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'Máquina de Vendas',
                to: '/omnichat',
                icon: 'mdi-robot',
                permissao: 'central_contatos_menu',
                dataCriacao: '2000-01-01'
            },
            {
                titulo: 'WoliHub',
                to: '/wolihub',
                icon: 'mdi-book-open-page-variant-outline',
                permissao: 'wolihub_menu',
                dataCriacao: '2026-05-26'
            }
        ]
    }
];

/**
 * Itens de menu fixos que aparecem sempre (não dependem de permissões principais)
 */
export const menuFixo = [
    {
        titulo: 'Meu usuário',
        to: '/meu-usuario',
        icon: 'mdi-account-circle',
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Normativas',
        to: '/normativa',
        icon: 'mdi-bookshelf',
        permissao: 'normativa',
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Chamados',
        to: '/chamado',
        icon: 'mdi-comment-question-outline',
        permissao: 'chamado',
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Desenvolvimento',
        to: '/projeto',
        icon: 'mdi-responsive',
        permissao: 'projeto',
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Liberações Cimento',
        to: '/liberacao',
        icon: 'mdi-cart-check',
        permissao: 'liberacao_submenu',
        dataCriacao: '2000-01-01'
    },
    {
        titulo: 'Ferramentas',
        to: '/ferramenta',
        icon: 'mdi-hammer-screwdriver',
        permissao: 'ferramenta',
        dataCriacao: '2000-01-01'
    }
];